import { HttpErrorResponse } from '@angular/common/http'
import { createAction, props } from '@ngrx/store'
import { UserAccountsEntity } from './user-accounts.models'

export const loadUserAccounts = createAction(
  '[UserAccounts/API] Load User Accounts',
  props<{ shouldReset: boolean; searchTerm: string; ordering: string }>(),
)
export const loadUserAccountsSuccess = createAction(
  '[UserAccounts/API] Load User Accounts Success',
  props<{ userAccounts: UserAccountsEntity[]; count: number }>(),
)
export const loadUserAccountsFailure = createAction(
  '[UserAccounts/API] Load User Accounts Failure',
  props<{ error: HttpErrorResponse }>(),
)
export const setUserAccounts = createAction(
  '[UserAccounts/API] Set User Accounts',
  props<{ userAccounts: UserAccountsEntity[]; count: number }>(),
)

export const displayGrid = createAction('[UserAccounts/API] Display Grid View')

export const displayTable = createAction('[UserAccounts/API] Display Table View')

export const openArchiveUserDialog = createAction(
  '[UserAccounts/Page] Open Archive User Dialog',
  props<{ uuid: string }>(),
)

export const archiveUser = createAction('[UserAccounts/API] Archive User')

export const archiveUserSuccess = createAction(
  '[UserAccounts/API] Archive User Success',
  props<{ userAccount: UserAccountsEntity }>(),
)

export const archiveUserFailure = createAction(
  '[UserAccounts/API] Archive User Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const removeFromUnsubscribeList = createAction(
  '[UserAccounts/API] Remove From Unsubscribe List',
  props<{ uuid: string; email: string }>(),
)

export const removeFromUnsubscribeListSuccess = createAction(
  '[UserAccounts/API] Remove From Unsubscribe List Success',
  props<{ uuid: string }>(),
)

export const removeFromUnsubscribeListFailure = createAction(
  '[UserAccounts/API] Remove From Unsubscribe List Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const clearSelectedId = createAction('[UserAccounts/API] Clear Selected Id')
